import LogoSVG from './images/LogoImage';
import LogoLink from './LogoLink';

const Logo = (props) => {
  return <LogoLink image={<LogoSVG />} {...props} />;
};

export default Logo;
